module.exports = __webpack_public_path__ + "img/09.2d603a88.png";